
import { Component, Vue } from "vue-property-decorator";
import Presolicitud from "@/models/Presolicitud";
import { AxiosResponse } from "axios";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import AfiliadoService from "@/services/AfiliadoService";
import moment from "moment";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";

@Component({})
export default class SolicitudBeneficiario extends Vue {
    public afiliadoService: AfiliadoService = new AfiliadoService();
    public loading = false;
    public currentPage: number = 1;
    public totalRows: number = null;
    public fieldNameToSortBy: string = "fechaDeRegistro";
    public sortByDesc: boolean = true;
    public fields: Array<{
        key: string;
        label: string;
        sortable: boolean;
        formatter?: (value: any, key: any, item: any) => any;
    }> = [
            {
                key: "numeroDeRegistro",
                label: "Registro No.",
                sortable: true,
            },
            { key: "tipoDeSolicitud", label: "Tipo de Solicitud", sortable: true },
            {
                key: "fechaDeRegistro",
                label: "Fecha de Registro",
                sortable: true,
                formatter: (value: any) => {
                    return this.formatFechaAfpSiembra(value);
                },
            },
            { key: "estado", label: "Estado", sortable: true },
            { key: "motivo", label: "Motivo", sortable: true },
            { key: "opciones", label: "Ver más", sortable: false },
        ];
    public solicitudes: Array<{
        numeroDeRegistro: number;
        tipoDeSolicitud: string;
        fechaDeRegistro: string;
        estado: string;
        motivo: string;
        opciones: {};
        tipoDeBeneficio: string;
        docFirmado: boolean;
        idTransFirma: string;
        solCancelada: boolean;
    }> = [];
    public searchTerm: string = null;
    public searchBy: Array<string> = [
        "numeroDeRegistro",
        "tipoDeSolicitud",
        "fechaDeRegistro",
        "estado",
        "motivo",
    ];

    public mounted(): void {
        this.loading = true;
        this.afiliadoService
            .getPresolicitud(
                new ParametrosObtencionPresolicitud(
                    null,
                    this.$store.state.user.cedula,
                    null,
                    null
                )
            )
            .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
                if (
                    response.data.solicitudes &&
                    response.data.solicitudes.length > 0
                ) {
                    this.solicitudes = response.data.solicitudes.map(
                        (presolicitud: Presolicitud) => {
                            return {
                                numeroDeRegistro: presolicitud.numeroSolicitud,
                                tipoDeSolicitud: presolicitud.descTipoBeneficio,
                                fechaDeRegistro: presolicitud.fechaSolicitud,
                                estado: presolicitud.estadoDesc,
                                motivo: presolicitud.motivo,
                                opciones: null,
                                tipoDeBeneficio: presolicitud.tipoBeneficio,
                                docFirmado: presolicitud.docFirmado,
                                idTransFirma: presolicitud.idTransFirma,
                                solCancelada: presolicitud.solCancelada
                            };
                        }
                    );
                    this.totalRows = this.solicitudes.length;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    public viewMore(
        numeroSolicitud: number,
        tipoDeBeneficio: number,
        docFirmado: boolean,
        idTransFirma: string
    ): void {
        let path: string = null;
        let query: any = {};
        switch (Number(tipoDeBeneficio)) {
            case TipoBeneficioEnum.IngresoTardio:
                if (docFirmado) {
                    path = "/resumen-solicitud-it";
                    query = { packageId: idTransFirma };
                } else {
                    path = "/registro-ingreso-tardio";
                    query = { numeroSolicitud: numeroSolicitud.toString() };
                }
                break;
            case TipoBeneficioEnum.Fallecimiento:
                path = "/registro-sobrevivencia";
                query = { numeroSolicitud: numeroSolicitud.toString() };
                break;
            case TipoBeneficioEnum.Cesantia:
                if (docFirmado) {
                    path = "/resumen-solicitud-cesantia";
                    query = { packageId: idTransFirma };
                } else {
                    path = "/registro-cesantia";
                    query = { numeroSolicitud: numeroSolicitud.toString() };
                }
                break;
            case TipoBeneficioEnum.VejezAnticipada:

                if (docFirmado) {
                    path = "/resumen-solicitud-vejez-anticipada";
                    query = { packageId: idTransFirma };
                } else {
                    path = "/registro-vejez-anticipada";
                    query = { numeroSolicitud: numeroSolicitud.toString() };
                }

                break;
        }
        this.$router.push({
            path: path,
            query: query,
        });
    }

    public redirectToHomeScreen(): void {
        this.$router.push("/home");
    }

    public formatFechaAfpSiembra(fecha: string): string {
        return moment(fecha).format("DD-MMM-YYYY");
    }

    public updatePagination(data: any, rows: number): void {
        if (!this.searchTerm) {
            this.totalRows = this.solicitudes.length;
        } else {
            this.totalRows = rows;
        }
    }
}
